<template>
    <!--赠片成功 开始-->
    <div class="main_container page_success" v-if="giveResult.result === 'suc'">
        <div class="mod_result_list">
            <div class="result_list_inner">
                <i class="icon_success"></i>
                <p class="result_tips">赠送成功</p>
                <div class="result_txt">
                    <p class="txt">您剩余赠送次数：{{giveResult.ticketNum}}次</p>
                </div>
                <div class="result_btn">
                    <a href="//film.qq.com/weixin/giverecord.html" class="btn_a">查看我的赠片记录</a>
                </div>
                <div class="result_more">
                    <a v-if="giveResult.ticketNum" class="link_more" @click="openMore">继续挑选影片赠送 &gt;</a>
                </div>
            </div>
        </div>
    </div>
    <!--赠片成功 结束-->
</template>

<script>
export default {
  props: ['giveResult', 'showPayBtn'],
  data () {
    return {

    }
  }
}
</script>
